import { createContext, useContext, useState, ReactNode } from 'react'

interface AppThemeContextType {
  brandColor: string
  setBrandColor: (color: string) => void
}

const AppThemeContext = createContext<AppThemeContextType | undefined>(undefined)

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const [brandColor, setBrandColor] = useState('#A35BFF') // Default Webba brand color

  return (
    <AppThemeContext.Provider value={{ brandColor, setBrandColor }}>
      {children}
    </AppThemeContext.Provider>
  )
}

export function useAppTheme() {
  const context = useContext(AppThemeContext)
  if (context === undefined) {
    throw new Error('useAppTheme must be used within an AppThemeProvider')
  }
  return context
}
